import React from "react"
import { ContactUs } from "./ContactUs"
import ContactoForm from "./ContactoForm"

const Contacto = () => {
    return <ContactoForm />
}

export default Contacto
